import React from 'react';
import { useField } from 'react-final-form';

import { InputLabel, Stack, ToggleButtonGroup } from '@mui/material';

type Props = {
  label: string;
  name: string;
  children: JSX.Element | JSX.Element[];
};

export default function ToolbarToggleInput({ label, name, children }: Props) {
  const {
    input: { value, onChange },
  } = useField(name);

  return (
    <Stack alignItems="flex-start">
      <InputLabel shrink>{label}</InputLabel>
      <ToggleButtonGroup
        exclusive
        value={value}
        fullWidth
        size="small"
        onChange={(ev, value) => {
          onChange(value);
        }}
      >
        {children}
      </ToggleButtonGroup>
    </Stack>
  );
}
